import makeState from './state'
import makeGetters from './getters'
import makeMutations from './mutations'
import makeActions from './actions'

const globalDefaults = {
  idField: 'id', // The field in each record that will contain the id
  autoRemove: false, // automatically remove records missing from responses (only use with feathers-rest)
  nameStyle: 'short', // Determines the source of the module name. 'short', 'path', or 'explicit'
  apiPrefix: '' // Setting to 'api1/' will prefix the store moduleName, unless `namespace` is used, then this is ignored.
}

export default function servicePluginInit (servicePath, options = {}) {
  return store => {
    const defaultState = makeState(servicePath, Object.assign({}, globalDefaults, options))
    const defaultGetters = makeGetters()
    const defaultMutations = makeMutations()
    const defaultActions = makeActions(options.apiUrl)

    store.registerModule(servicePath, {
      namespaced: true,
      state: Object.assign({}, defaultState, options.state),
      getters: Object.assign({}, defaultGetters, options.getters),
      mutations: Object.assign({}, defaultMutations, options.mutations),
      actions: Object.assign({}, defaultActions, options.actions)
    })
  }
}
